import { getRandomStr } from "./randomStr";


function bin2hex(s) {
  let i, l, o = '',
    n;

  s += '';

  for (i = 0, l = s.length; i < l; i++) {
    n = s.charCodeAt(i)
      .toString(16);
    o += n.length < 2 ? '0' + n : n;
  }

  return o;
}


function getLocalrandomStr() {
  if (!localStorage.getItem('randomStr')) {
    localStorage.setItem('randomStr', getRandomStr(14));
  };
  return localStorage.getItem('randomStr');
}

function getUUID(domain) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext("2d");
    let txt = domain + '&_str=' + getLocalrandomStr();
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "tencent";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125,1,62,20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);

    let b64 = canvas.toDataURL().replace("data:image/png;base64,","");
    let bin = atob(b64);
    let crc = bin2hex(bin.slice(-20,-12));
    return crc;
}

export default getUUID;